// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer__3FWSH","footer_hexa":"Footer__footer_hexa__1rL2y","social_icons":"Footer__social_icons__3e_of","contact_info":"Footer__contact_info__8gDxq"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Footer/Footer.scss
// module id = 116
// module chunks = 0